"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _useFetchAsJson3 = _interopRequireDefault(require("@eig-builder/core-utils/hooks/useFetchAsJson"));

var _urlHelper = require("@eig-builder/core-utils/helpers/url-helper");

var _currentLanguageHelper = _interopRequireDefault(require("@eig-builder/core-utils/helpers/current-language-helper"));

var _translationProductHelper = _interopRequireDefault(require("./../helpers/translation-product-helper"));

var _localization = _interopRequireDefault(require("../components/localization"));

var getTranslations = function getTranslations(doFetch, setTranslationKeys) {
  var translationKeys = typeof window !== "undefined" && window.runtimeTranslation;

  if (translationKeys) {
    setTranslationKeys(translationKeys);
  } else {
    var language = (0, _currentLanguageHelper["default"])();
    var productName = (0, _translationProductHelper["default"])();
    doFetch({
      url: (0, _urlHelper.getUrl)(_urlHelper.siteNames.TRANSLATION, "/v1.0/translations?productName=".concat(productName, "&groupName=Javascript&language=").concat(language), {
        useCdn: true
      })
    });
  }
};

var TranslatingLocalizationContainer = function TranslatingLocalizationContainer(props) {
  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      translationKeys = _useState2[0],
      setTranslationKeys = _useState2[1];

  var _useFetchAsJson = (0, _useFetchAsJson3["default"])(),
      _useFetchAsJson2 = (0, _slicedToArray2["default"])(_useFetchAsJson, 2),
      translationReq = _useFetchAsJson2[0],
      doFetch = _useFetchAsJson2[1];

  (0, _react.useEffect)(function () {
    getTranslations(doFetch, setTranslationKeys);
  }, []);
  (0, _react.useEffect)(function () {
    if (translationReq.data) {
      setTranslationKeys(translationReq.data);
    }
  }, [translationReq.data]);
  return translationKeys && /*#__PURE__*/_react["default"].createElement(_localization["default"], (0, _extends2["default"])({
    retrieving: false,
    translationKeys: translationKeys,
    error: null
  }, props));
};

var _default = TranslatingLocalizationContainer;
exports["default"] = _default;